module.exports = __webpack_public_path__ + "assets/47646f8af08937df811a539876a2e0e8.mp3";